<template>
  <div class="inflationMaintenance">
    <my-head :title="title"/>

    <div class="auto-width inflationMaintenance-box">
      <mu-text-field v-model="form.vin" v-show="isNullTask" @blur="" placeholder="VIN" ref="vin" class='input auto-width' @keyup.enter.native="getData()"><i class="iconfont icon-saomiao" @click="scan('vin')"></i></mu-text-field>

      <!-- <mu-card class="my-null" v-show="isNullTask">当前无任务</mu-card> -->
      
      <mu-card class="my-card" v-show="isShowCardInfo" v-for="(item, index) in task">
        <mu-row align-items="center">
          <mu-col span="8"><div class="grid-cell">单号：{{item.code}}</div></mu-col>
          <mu-col span="4"><div class="grid-cell">{{item.status}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">VIN：{{item.vin}}</div></mu-col>
          <mu-col span="6"><div class="grid-cell">车型：{{item.carType}}</div></mu-col>
          <mu-col span="6"><div class="grid-cell">颜色：{{item.color}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">库位：{{item.location}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">领取任务日期：{{item.startDate}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">计划完成日期：{{item.planDate}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">备注：{{item.remarks}}</div></mu-col>
          <mu-col span="3"><div class="grid-cell">充前胎压：</div></mu-col>
          <mu-col span="9">
            <div class="grid-cell flex">
              <mu-text-field v-model="item.beforeLeftFront" :disabled="true" placeholder="左前" ref="beforeLeftFront" type="number" class='auto-width-s ft'></mu-text-field>
              <mu-text-field v-model="item.beforeRightFront" :disabled="true" placeholder="右前" ref="beforeRightFront" type="number" class='auto-width-s ft'></mu-text-field>
              <mu-text-field v-model="item.beforeLeftRear" :disabled="true" placeholder="左后" ref="beforeLeftRear" type="number" class='auto-width-s ft'></mu-text-field>
              <mu-text-field v-model="item.beforeRightRear" :disabled="true" placeholder="右后" ref="beforeRightRear" type="number" class='auto-width-s ft'></mu-text-field>
            </div>
          </mu-col>
          <mu-col span="3"><div class="grid-cell">充后胎压：</div></mu-col>
          <mu-col span="9">
            <div class="grid-cell flex">
              <mu-text-field v-model="item.afterLeftFront" placeholder="左前" @focus="openSelector('ty', item, 'afterLeftFront', index)" ref="afterLeftFront" type="number" class='auto-width-s ft'></mu-text-field>
              <mu-text-field v-model="item.afterRightFront" placeholder="右前" @focus="openSelector('ty', item, 'afterRightFront', index)" ref="afterRightFront" type="number" class='auto-width-s ft'></mu-text-field>
              <mu-text-field v-model="item.afterLeftRear" placeholder="左后" @focus="openSelector('ty', item, 'afterLeftRear', index)" ref="afterLeftRear" type="number" class='auto-width-s ft'></mu-text-field>
              <mu-text-field v-model="item.afterRightRear" placeholder="右后" @focus="openSelector('ty', item, 'afterRightRear', index)" ref="afterRightRear" type="number" class='auto-width-s ft'></mu-text-field>
            </div>
          </mu-col>
        </mu-row>
      </mu-card>
    </div>

    <div class="maintenance-btn auto-width fixed">
      <mu-button full-width color="primary" v-show="isShowCardInfo" @click="goBackTask">回退任务</mu-button>
      <mu-button full-width color="primary" v-show="isShowCardInfo" @click="saves">充气确认</mu-button>
      <mu-button full-width color="primary" v-show="isNullTask" @click="receive">领取任务</mu-button>
    </div>


    <mu-bottom-sheet :open.sync="selector">
      <div class="bottom-sheet-mine">
        <div @click="cancelValue">取消</div>
        <div @click="sureValue">确认</div>
      </div>
      <mu-slide-picker :slots="slots" :visible-item-count="5" @change="selectValueChange" :values="val"></mu-slide-picker>
    </mu-bottom-sheet>

    <!--图片全屏预览-->
    <!-- <mu-dialog width="360" transition="slide-bottom" fullscreen :open.sync="openFullscreen">
      <mu-appbar color="" title="">
      <mu-button slot="right" flat  @click="closeFullscreenDialog">关闭</mu-button>
      </mu-appbar>
      <div id='ylbox'>
          <mu-carousel :cycle="false">
              <mu-carousel-item>
                  <img :src="bigImg">
              </mu-carousel-item>
          </mu-carousel>
      </div>
    </mu-dialog>

    <div class="photos">
      <div class="imgs" v-for="(item, index) in src" :key="index" @touchstart.stop="touchin(index)" @touchend.stop="cleartime()" @click.stop="openFullscreenDialog(index)">
          <img :src="item" >
      </div>
      <i class="iconfont icon-icon25201" @click="paizhao"></i>
    </div>
    
    <mu-dialog width="320" max-width="60%" :open.sync="openAlert">
      确认删除图片?
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialog('n')">取消</mu-button>
      <mu-button slot="actions" flat color="primary" @click="closeAlertDialog('y')">删除</mu-button>
    </mu-dialog>
    

    <mu-data-table id="mytable" :loading="tableLoading" :columns="columns" :sort.sync="sort" @sort-change="handleSortChange" :data="list.slice(0, 6)">
      <template slot-scope="scope">
        <td>{{scope.row.name}}</td>
        <td>{{scope.row.unit}}</td>
        <td>{{scope.row.quantity}}</td>
        <td><mu-text-field v-model="scope.row.inflationMaintenanceQuantity"></mu-text-field></td>
      </template>
    </mu-data-table>

    <div class="inflationMaintenance-btns auto-width">
      <mu-button color="info">点检记录</mu-button>
      <mu-button color="info">提交</mu-button>
    </div> -->

    <scanning v-if="isScanning" :mark="scanMark" v-on:childByValue="childByValue" v-on:closeing="closeing"/>
  </div>
</template>

<script>
let lv = {}
for(let i=0; i<=100; i+= 10){
  lv[i] = 0;
}
let hv = {}
for(let i=0; i<=50; i+= 1){
  hv[i] = 0;
}
let ty = {}
for(let i=0; i<=3.9; i+= 0.05){
  ty[i.toFixed(2).toString()] = 0;
}
import myHead from '@/components/header'
import api from "@/common/api"
import scanning from "@/components/scanning"
export default {
  name: 'pickcar',
  components: {
    myHead, scanning
  },
  data () {
    return {
      slots: [{
        width: '100%',
        textAlign: 'center',
        values: Object.keys(lv)
      }],
      val: ["80", "0"],
      lvSlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(lv)
        }
      ],
      lv: ["80", "0"],
      hvSlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(hv)
        }
      ],
      hv: ["25", "0"],
      tySlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(ty)
        }
      ],
      ty: ["3.50", "0"],
      selector: false,
      valueRow: [],
      valueKey: "",
      valueIndex: -1,
      title: "充气保养",
      scanMark: "",
      isShowCardInfo: false,
      isNullTask: true,
      tableLoading: false,
      isScanning: false,
      openFullscreen: false,
      deleteIndex: null, // 删除第几张
      openAlert: false, // 删除图片层
      src: [], // 拍照的图片
      files: [], // 图片文件 base64
      showDetailedDialog: false,
      expandIndex: -1, // 当前选择行
      bigImg: null,
      otherTaskTo: false,
      form: {
        vin: "",
        orderNumber: "",
        checkbox: [],
        text: ""
      },
      options: ['正常', '异常'],
      sort: {
        name: '',
        order: 'asc'
      },
      requestOnce: true,
      columns: [
        { title: '保养项', width: 150, name: 'name' },
        { title: '状态', name: 'calories', width: 120, align: 'left'},
        { title: '保养值', name: 'fat', width: 200, align: 'left'}
      ],
      task: [],
      list: [
        
      ]
    }
  },
  methods: {
    cancelValue(){
      this.selector = false;
    },
    sureValue(){
      this.valueRow[this.valueKey] = this.val[0];
      // this.CheckAbnormal();
      this.selector = false;
    },
    selectValueChange (value, index) {
      this.val = [""+value, "0"];
      this.valueRow[this.valueKey] = value;
      // this.CheckAbnormal();
    },
    openSelector(type, row, key, index){
      this.selector = true;
      this.valueRow = row;
      this.valueKey = key;
      this.valueIndex = index;
      console.log(row, key, index);
      if(type == 'lv'){
        this.slots = this.lvSlots;
        this.val = this.lv;
      }else if(type == 'hv'){
        this.slots = this.hvSlots;
        this.val = this.hv;
      }else if(type == 'ty'){
        this.slots = this.tySlots;
        this.val = this.ty;
      }
      this.valueRow[this.valueKey] && (this.val = [this.valueRow[this.valueKey]+"", '0']);
    },
    goBackTask(){
      let data = Object.assign({},this.$store.state.user,{
        content: {
          task: this.task
        }
      });
      /* 发送post请求 */
      if(this.requestOnce){
        this.requestOnce = false;
        this.common.reqData(api.app('inflationMaintenanceCancel'), data, res=>{
          this.requestOnce = true;
          this.Toast.clear();
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            this.Toast({
              duration: 2000,
              mask: true,
              message: '回退成功'
            });
            this.isShowCardInfo = false;
            this.isNullTask = true;
          }else{
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    saves(){
      if(!this.task[0].afterLeftFront || !this.task[0].afterRightFront || !this.task[0].afterLeftRear || !this.task[0].afterRightRear){
        this.Toast({
          mask: true,
          message: '请填写完整的胎压后提交'
        });
        return false;
      }
      this.Toast.loading({message: '保存中'});
      let data = Object.assign({},this.$store.state.user,{
        content: {
          task: this.task
        }
      });
      /* 发送post请求 */
      if(this.requestOnce){
        this.requestOnce = false;
        this.common.reqData(api.app('maintenanceSaveInflation'), data, res=>{
          this.requestOnce = true;
          this.Toast.clear();
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            this.Toast({
              duration: 2000,
              mask: true,
              message: '保存成功'
            });
            this.isShowCardInfo = false;
          }else{
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    changeAbnormal(val, index){
      val == "异常" ? this.expandIndex = index : this.expandIndex = -1;
    },
    rowClick(index,row,event){
      row.status == "异常" ? this.expandIndex = index : this.expandIndex = -1;
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    hideDetailed(){
      this.showDetailedDialog = false;
    },
    showDetailed(){
      this.showDetailedDialog = true;
    },
    openFullscreenDialog (index) {
      this.bigImg = this.src[index];
      this.openFullscreen = true;
    },
    closeFullscreenDialog () {
      this.openFullscreen = false;
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    changeCheckBox(v){
      console.log(this.form.checkbox)
    },
    deleteImgDialog (index) {
      // 删除图片 打开
      this.deleteIndex = index;
      this.openAlert = true;
    },
    closeAlertDialog (state) {
      // 删除图片 关闭
      if(state === 'y'){
          this.src.splice(this.deleteIndex, 1);
          this.files.splice(this.deleteIndex, 1);
      }
      this.openAlert = false;
    },
    
    paizhao(){
      let _this = this;
      if(window.plus){
        var cmr = plus.camera.getCamera();
        var res = cmr.supportedImageResolutions[0];
        var fmt = cmr.supportedImageFormats[0];
        console.log("Resolution: "+res+", Format: "+fmt);
        cmr.captureImage( function( path ){
            plus.io.resolveLocalFileSystemURL( path, function ( entry ) {
                // 转化本地绝对路径
                var url = plus.io.convertLocalFileSystemURL(path);
                _this.src.push("file://"+url);
                // 获取图片对象
                entry.file( function(file){
                    var fileReader = new plus.io.FileReader();
                    fileReader.onloadend = function(evt) {
                        console.log(evt.target.result);
                        _this.files.push(evt.target.result);
                    }
                    fileReader.readAsDataURL(file);
                });
            });
        },
        function( error ) {
            console.log( "拍照已经取消: " + error.message );
        },
        {resolution:res,format:fmt}
        );
      }
    },
    receive(){
      this.Toast.loading({message: '领取中'});
      let data = Object.assign({},this.$store.state.user,{
        content: {
          vin: this.form.vin
        }
      });
      /* 发送post请求 */
      if(this.requestOnce){
        this.requestOnce = false;
        this.common.reqData(api.app('maintenanceGetInflationTask'), data, res=>{
          this.requestOnce = true;
          this.Toast.clear();
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            // this.Toast({
            //   duration: 2000,
            //   mask: true,
            //   message: '提交成功'
            // });
            this.task = res.data.content.task || [];
            this.isShowCardInfo = true;
            this.isNullTask = false;
          }else{
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    getData (){
      this.Toast.loading({message: '查询中'});
      let data = Object.assign({},this.$store.state.user,{
        content: {
          vin: this.form.vin
        }
      });
      /* 发送post请求 */
      if(this.requestOnce){
        this.requestOnce = false;
        this.common.reqData(api.app('maintenanceGetInflation'), data, res=>{
          this.requestOnce = true;
          this.Toast.clear();
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            // this.Toast({
            //   duration: 2000,
            //   mask: true,
            //   message: '提交成功'
            // });
            this.task = res.data.content.task || [];
            this.isShowCardInfo = true;
            this.isNullTask = false;
          }else{
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    closeing (val) {
      val ? this.isScanning = false : null;
    },
    childByValue (val) {
      if(val){
        if(val.split('&')[1] == 'vin'){
          this.form.vin = val.split('&')[0];
          this.getData();
        }
      }
    },
    scan (txt) {
      this.scanMark = txt;
      this.isScanning = true;
    },
    closeFullscreenDialog(){
      this.openFullscreen = false;
      this.closeScan();
    },
    scanQR(){
      this.openFullscreen = true;
      let _this = this;
      if (!window.plus) {return;}
      setTimeout(() => {
        scan = new plus.barcode.Barcode('bcid');
        scan.onmarked = onmarked;
        function onmarked(type, result, file) {
          switch (type) {
            case plus.barcode.QR:
              type = 'QR';
              break;
            case plus.barcode.EAN13:
              type = 'EAN13';
              break;
            case plus.barcode.EAN8:
              type = 'EAN8';
              break;
            default:
              type = '其它' + type;
              break;
          }
          result = result.replace(/\n/g, '');
          _this.form.vin = result;
          _this.closeScan();
        }
      }, 40);
    },
    //开始扫描
    startScan() {
      if (!window.plus) {return;}
      scan.start();
    },
    //关闭
    closeScan() {
      this.openFullscreen = false;
      if (!window.plus) {return;}
      scan.close();
    },
  },
  mounted () {
    this.getData();
  },
  watch: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auto-width{
  width: 100%;
  max-width: 375px;
  margin: 10px auto;
}
.my-null{
  color: red;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 15px;
  margin-bottom: 2rem;
}
.detailed{
  padding: 15px;
  height: calc(100% - 56px);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto; 
}
.my-card{
  margin-bottom: 2rem;
  padding: 15px;
}
.input{
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
#mytable .mu-input{
  width: 100%;
  margin: 0;
}
.inflationMaintenance-btns{
  display: flex;
  width: 85%;
  margin-top: 20px;
  justify-content: space-between;
}
.inflationMaintenance-btns button{
  margin: 0 0;
}
.photos{
    border: 1px solid #ccc;
    width: 90%;
    margin: 20px auto 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
i.iconfont.icon-icon25201{
    display: block;
    font-size: 50px;
    margin: 10px;
}
.inflationMaintenance-box{
  padding-bottom: 50px;
}
.bottom-sheet-mine{
  display: flex;
  justify-content: space-around;
}
.bottom-sheet-mine > div{
  line-height: 2rem;
  background: #eee;
  padding: 0 20px;
  border-radius: 10px;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/maintenance/inflationMaintenance.vue